// @flow
import { Cookies } from 'react-cookie';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { fetchJSON } from '../../helpers/api';
import apiConfig from '../../config/routesApi';

import { LOGIN_USER, LOGOUT_USER, REGISTER_USER, FORGET_PASSWORD } from './constants';

import {
    loginUserSuccess,
    loginUserFailed,
    registerUserSuccess,
    registerUserFailed,
    forgetPasswordSuccess,
    forgetPasswordFailed,
} from './actions';

/**
 * Sets the session
 * @param {*} user
 */
const setSession = (userToken, userInfo) => {
    let cookies = new Cookies();
    if (userToken) cookies.set('user_access', JSON.stringify(userToken), { path: '/' });
    else cookies.remove('user_access', { path: '/' });
    if (userInfo) cookies.set('user_info', JSON.stringify(userInfo), { path: '/' });
    else cookies.remove('user_info', { path: '/' });
};
/**
 * Login the user
 * @param {*} payload - username and password
 */
function* login({ payload: { username, password } }) {
    var formData = new FormData();

    formData.append("grant_type", "password");
    formData.append("username", username);
    formData.append("password", password);
    formData.append("client_id", "logistic_client");
    formData.append("client_secret", "secret");

    const options = {
        body: formData,
        method: 'POST',
    };

    const response = yield call(fetchJSON, apiConfig.apiGateway.authen + apiConfig.apiEventLogistic.postAuthentication, options);
    if(response.access_token === undefined || response.access_token === null)
    {
        yield put(loginUserFailed("Invalid credentials"));
        setSession(null, null);
    }
    else
    {
        const optionsCurrentUser = {
            method: 'GET',
            headers: { 'Authorization': 'Bearer ' + response.access_token },
        }
        const responseCurrentUser = yield call(fetchJSON, apiConfig.apiGateway.authen + apiConfig.apiEventLogistic.getCurrentUser, optionsCurrentUser);
        if(responseCurrentUser.data)
        {
            setSession(response, responseCurrentUser.data);
        }
        else
        {
            setSession(null, null);
        }

        yield put(loginUserSuccess(response));
        window.location.reload();
    }
}

/**
 * Logout the user
 * @param {*} param0
 */
function* logout({ payload: { history } }) {
    try {
        setSession(null, null);
        yield call(() => {
            history.push('/account/login');
        });
    } catch (error) {}
}

/**
 * Register the user
 */
function* register({ payload: { fullname, email, password } }) {
    const options = {
        body: JSON.stringify({ fullname, email, password }),
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
    };

    try {
        const response = yield call(fetchJSON, '/users/register', options);
        yield put(registerUserSuccess(response));
    } catch (error) {
        let message;
        switch (error.status) {
            case 500:
                message = 'Internal Server Error';
                break;
            case 401:
                message = 'Invalid credentials';
                break;
            default:
                message = error;
        }
        yield put(registerUserFailed(message));
    }
}

/**
 * forget password
 */
function* forgetPassword({ payload: { username } }) {
    const options = {
        body: JSON.stringify({ username }),
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
    };

    try {
        const response = yield call(fetchJSON, '/users/password-reset', options);
        yield put(forgetPasswordSuccess(response.message));
    } catch (error) {
        let message;
        switch (error.status) {
            case 500:
                message = 'Internal Server Error';
                break;
            case 401:
                message = 'Invalid credentials';
                break;
            default:
                message = error;
        }
        yield put(forgetPasswordFailed(message));
    }
}

export function* watchLoginUser() {
    yield takeEvery(LOGIN_USER, login);
}

export function* watchLogoutUser() {
    yield takeEvery(LOGOUT_USER, logout);
}

export function* watchRegisterUser() {
    yield takeEvery(REGISTER_USER, register);
}

export function* watchForgetPassword() {
    yield takeEvery(FORGET_PASSWORD, forgetPassword);
}

function* authSaga() {
    yield all([fork(watchLoginUser), fork(watchLogoutUser), fork(watchRegisterUser), fork(watchForgetPassword)]);
}

export default authSaga;
